// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__2XQfw","savePackageButton":"ClientWallet_savePackageButton__21BZL"};